import type { CSSProperties, MouseEventHandler } from 'react';

import { Colors } from '@treneo/shared/themes';

import type { SxProps, Theme } from '@mui/material';

export const IconSizes = {
  inherit: 'inherit',
  small: 'small',
  medium: 'medium',
  large: 'large'
} as const;

export type IconSize = (typeof IconSizes)[keyof typeof IconSizes];

export const IconColors = {
  inherit: 'inherit',
  primary: 'primary',
  secondary: 'secondary',
  action: 'action',
  error: 'error',
  disabled: 'disabled',
  warning: 'warning'
} as const;

export type IconColor = (typeof IconColors)[keyof typeof IconColors];

export type IconProps = Readonly<{
  fontSize?: IconSize;
  color?: IconColor;
  sx?: SxProps<Theme>;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<SVGSVGElement>;
}>;

export const IconDefaults = {
  fontSize: IconSizes.medium,
  color: IconColors.inherit
} as const;

export const getIconColorProps = (color: IconColor, sx?: SxProps<Theme>) => {
  if (color === IconColors.warning) {
    return {
      color: IconColors.inherit,
      sx: { color: Colors.warning, ...sx }
    };
  }

  return { color, sx };
};
